import _ from 'lodash';
import React from 'react';

import ArtistsFilterBar from './artists-filter-bar';
import AddArtistButton from './add-artist-button';
import ArtistSearchBar from './artist-search-bar';

class ManageArtistsHeader extends React.Component {
	render () {

		return (
			<div>
				<div className="grid-x small-12 align-middle align-justify">
					<div className="cell small-4 auto padding-left-1 padding-top-1">
						<h3 data-ta="manageArtistsHeader">Manage Artists</h3>
					</div>

					<div className="cell small-4 align-middle">
						<ArtistSearchBar 
							searchTerm={ this.props.searchTerm }
							searchChange={ this.props.searchChange }
						/>
					</div>
					<div className="cell small-4">
						<AddArtistButton />
					</div>

				</div>
				<div className="cell small-12">
					
					<ArtistsFilterBar />
				</div>
			</div>
		);
	}
}

export default ManageArtistsHeader;
